import { find, forEach, mapValues } from 'lodash';
export function validate(constraints, values) {
    var result = {};
    forEach(constraints, function (validators, name) {
        var value = values[name];
        find(validators, function (validator) {
            var error = validator(value);
            if (error) {
                result[name] = error;
                return true;
            }
            return false;
        });
    });
    return result;
}
export function validateAndTranslate(constraints, values, t) {
    return mapValues(validate(constraints, values), function (error) {
        return t(error.key, error.options);
    });
}
export var createValidator = function (constraints) { return function (values) {
    return validate(constraints, values);
}; };
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/validators/dist/utils.js
// module id = 1617
// module chunks = 118